import { etapaLabel } from "./pipelineUtils";

export const CAMPOS_EDICION_LEAD = [
  { key: "archivado", label: "Estado de archivo" },
  { key: "fechaContacto", label: "Fecha de contacto" },
  { key: "nombre", label: "Nombre" },
  { key: "edad", label: "Edad" },
  { key: "telefono", label: "Teléfono" },
  { key: "codigoPais", label: "Código país" },
  { key: "cursoInteres", label: "Producto/Servicio" },
  { key: "montoEstimado", label: "Monto estimado" },
  { key: "canal", label: "Canal" },
  { key: "observaciones", label: "Observaciones" },
  { key: "vendedorId", label: "Vendedor" },
  { key: "zona", label: "Zona" },
  { key: "proximoSeguimiento", label: "Próximo seguimiento" },
  { key: "location", label: "Ubicación" },
];

const normalizarScalar = (valor) => {
  if (valor == null) return "";
  return String(valor).trim();
};

const normalizarLocation = (valor) => {
  if (!valor || typeof valor !== "object") return "";
  const lat = valor.lat ?? valor.latitude;
  const lng = valor.lng ?? valor.longitude;
  if (lat == null || lng == null) return "";
  return `${Number(lat).toFixed(5)},${Number(lng).toFixed(5)}`;
};

export function valoresLeadIguales(key, anterior, nuevo) {
  if (key === "archivado") return Boolean(anterior) === Boolean(nuevo);
  if (key === "montoEstimado") {
    const a = Number(anterior);
    const b = Number(nuevo);
    const na = Number.isFinite(a) && a > 0 ? Math.round(a * 100) : null;
    const nb = Number.isFinite(b) && b > 0 ? Math.round(b * 100) : null;
    return na === nb;
  }
  if (key === "location") {
    return normalizarLocation(anterior) === normalizarLocation(nuevo);
  }
  return normalizarScalar(anterior) === normalizarScalar(nuevo);
}

function nombreVendedor(config, id) {
  if (!id) return "—";
  const v = config?.vendedores?.find((item) => item.id === id);
  return v?.nombre || id;
}

export function formatearValorLead(campo, valor, config) {
  if (campo === "archivado") return valor ? "Archivado" : "Activo";
  if (campo === "montoEstimado") {
    const n = Number(valor);
    if (!Number.isFinite(n) || n <= 0) return "—";
    const moneda = config?.moneda ? `${config.moneda} ` : "";
    return `${moneda}${n.toLocaleString()}`;
  }
  if (campo === "location") {
    const texto = normalizarLocation(valor);
    return texto || "—";
  }
  if (campo === "vendedorId") return nombreVendedor(config, valor);
  if (campo === "proximoSeguimiento" && valor) {
    try {
      return new Date(valor).toLocaleDateString();
    } catch {
      return normalizarScalar(valor) || "—";
    }
  }
  const texto = normalizarScalar(valor);
  return texto || "—";
}

export function crearEntradaHistorialEdicion(leadId, anterior, cambios, config, uid, ahora) {
  const registros = [];

  CAMPOS_EDICION_LEAD.forEach(({ key, label }) => {
    if (!(key in cambios)) return;
    const valorNuevo = cambios[key];
    const valorAnterior = anterior[key];
    if (valoresLeadIguales(key, valorAnterior, valorNuevo)) return;
    registros.push({
      campo: key,
      etiqueta: label,
      valorAnterior: formatearValorLead(key, valorAnterior, config),
      valorNuevo: formatearValorLead(key, valorNuevo, config),
    });
  });

  if (registros.length === 0) return null;

  return {
    id: uid(),
    leadId,
    fechaHora: ahora(),
    cambios: registros,
  };
}

export function historialEtapasPorLead(historialEtapas, leadId) {
  return (historialEtapas || [])
    .filter((h) => h.leadId === leadId)
    .sort((a, b) => (b.fechaHora || "").localeCompare(a.fechaHora || ""));
}

export function historialEdicionesPorLead(historialEdiciones, leadId) {
  return (historialEdiciones || [])
    .filter((h) => h.leadId === leadId)
    .sort((a, b) => (b.fechaHora || "").localeCompare(a.fechaHora || ""));
}

export function describirMovimientoEtapa(config, entrada) {
  const destino = etapaLabel(config, entrada.etapaNueva);
  if (entrada.etapaAnterior == null || entrada.etapaAnterior === "") {
    return `Lead creado en «${destino}»`;
  }
  const origen = etapaLabel(config, entrada.etapaAnterior);
  return `«${origen}» → «${destino}»`;
}
